// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__18-Lu","bigColWidth":"Table_bigColWidth__2qcrt","biggerColWidth":"Table_biggerColWidth__i_vOy","row":"Table_row__1o5Bb","col":"Table_col__4O42y"};